/**
 * 配置常量
 */

// API 配置
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1',
  TIMEOUT: 30000,
  /** AI Session 创建 Run / 消息可能排队等待会话锁，需长于默认 30s */
  AI_SESSION_MUTATION_TIMEOUT: 180_000,
  USE_MOCK: import.meta.env.VITE_USE_MOCK === 'true',
};

// 应用配置
export const APP_CONFIG = {
  TITLE: import.meta.env.VITE_APP_TITLE || 'Jointo',
  ENV: import.meta.env.VITE_APP_ENV || 'development',
};

// AI 助手入口配置
export const AI_ASSISTANT_UI_CONFIG = {
  // 暂时隐藏资产生成期间的「可并行推进 / 先进入分镜」，后续开放时改为 true。
  SHOW_EARLY_STORYBOARD_ENTRY: false,
};

// 视频配置
export const VIDEO_CONFIG = {
  ASPECT_RATIOS: ['16:9', '9:16', '1:1', '4:3', '21:9'] as const,
  FRAME_RATES: [24, 25, 30, 60] as const,
  DEFAULT_ASPECT_RATIO: '16:9' as const,
  DEFAULT_FRAME_RATE: 30,
};

// 时间轴配置
export const STORYBOARD_BOARD_CONFIG = {
  MIN_ZOOM: 0.1,
  MAX_ZOOM: 5,
  DEFAULT_ZOOM: 1,
  PIXELS_PER_SECOND: 50,
  SNAP_THRESHOLD: 10, // 吸附阈值（像素）
  MIN_DURATION: 0.5, // 最小时长（秒）
};

// 分镜配置
export const STORYBOARD_CONFIG = {
  DEFAULT_DURATION: 5, // 默认时长（秒）
  MIN_DURATION: 1,
  MAX_DURATION: 60,
};

// 上传配置
export const UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_VIDEO_TYPES: ['video/mp4', 'video/webm', 'video/quicktime'],
  ALLOWED_AUDIO_TYPES: ['audio/mpeg', 'audio/wav', 'audio/ogg'],
};
